import * as React from 'react';
import { SVGProps } from 'react';

const SvgBookmark = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={12} height={16} viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.746.88a2.15 2.15 0 0 1 1.52-.63h7.467a2.15 2.15 0 0 1 2.15 2.15V15a.75.75 0 0 1-1.191.607L6 12.194l-4.693 3.413A.75.75 0 0 1 .117 15V2.4c0-.57.226-1.117.629-1.52Zm1.52.87a.65.65 0 0 0-.65.65v11.127l3.942-2.867a.75.75 0 0 1 .883 0l3.942 2.867V2.4a.65.65 0 0 0-.65-.65H2.266Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgBookmark;
